import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";

export interface IPriceCitiesSummary {
    date: string;
    city: string;
    slug: string;
    availableOffers: number;
    avgPrice: number;
    avgPriceM2: number;
    oldAvailableOffers: number;
    oldAvgPrice: number;
    oldAvgPriceM2: number;
}

export const getCitiesData = () => {
    const actualCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesData);
    const oldCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesDataOld);

    if (actualCitiesData && actualCitiesData.length && oldCitiesData && oldCitiesData.length) {
        return actualCitiesData.reduce((acc, curr) => {
            const oldCityData = oldCitiesData.find((oldData) => oldData.city === curr.city);
            if (oldCityData) {
                return [
                    ...acc,
                    {
                        date: curr.date,
                        city: curr.city,
                        slug: curr.slug_city,
                        availableOffers: curr.available_offers,
                        avgPrice: curr.avg_price,
                        avgPriceM2: curr.avg_price_m2,
                        oldAvailableOffers: oldCityData.available_offers,
                        oldAvgPrice: oldCityData.avg_price,
                        oldAvgPriceM2: oldCityData.avg_price_m2
                    }
                ];
            }
            return acc;
        }, [] as IPriceCitiesSummary[]);
    }

    return [] as IPriceCitiesSummary[];
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";

export interface IPriceCitiesSummary {
    date: string;
    city: string;
    slug: string;
    availableOffers: number;
    avgPrice: number;
    avgPriceM2: number;
    oldAvailableOffers: number;
    oldAvgPrice: number;
    oldAvgPriceM2: number;
}

export const getCitiesData = () => {
    const actualCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesData);
    const oldCitiesData = useSelector((store: IRPStore) => store.report.price.allCitiesDataOld);

    if (actualCitiesData && actualCitiesData.length && oldCitiesData && oldCitiesData.length) {
        return actualCitiesData.reduce((acc, curr) => {
            const oldCityData = oldCitiesData.find((oldData) => oldData.city === curr.city);
            if (oldCityData) {
                return [
                    ...acc,
                    {
                        date: curr.date,
                        city: curr.city,
                        slug: curr.slug_city,
                        availableOffers: curr.available_offers,
                        avgPrice: curr.avg_price,
                        avgPriceM2: curr.avg_price_m2,
                        oldAvailableOffers: oldCityData.available_offers,
                        oldAvgPrice: oldCityData.avg_price,
                        oldAvgPriceM2: oldCityData.avg_price_m2
                    }
                ];
            }
            return acc;
        }, [] as IPriceCitiesSummary[]);
    }

    return [] as IPriceCitiesSummary[];
};
